/* useBackend = true means that the production backend will be used */
/* useBackend = false means that the local backend will be used */

const useBackend = false;
const base_url =
  process.env.NODE_ENV === "development" && !useBackend
    ? "http://localhost:8000/"
    : "https://rgm-backend-g0aggfdnbqamg4ap.eastus2-01.azurewebsites.net/";

// Routes definition
const apiRoutes = {
  // Base
  base_url,

  // Token
  token_obtain_pair: "token/",
  token_refresh: "token/refresh/",

  // Accounts
  accounts_postlogin_info: "api/post_login_info/",
  accounts_changepassword: "api/change_password/",
  accounts_changeproject: "api/change_project/",

  // Extras
  extras_contact_request: "api/contact_request/",

  // Admin View
  adminview_groups: "api/admin_groups/",
  adminview_groups_save: "api/admin_group_save/",
  adminview_user_mgmt: "api/user_management/",
  adminview_user_mgmt_roles_save: "api/user_management_save_roles/",

  // BQ test
  bqtest_upload: "api/bq-test/upload/",

  // Inputs
  inputs: {
    metadata: "/api/inputs/metadata/",
    columns: "/api/inputs/columns/",
    groups: "/api/inputs/groups/",
    files: "/api/inputs/files/",
    prepare: "/api/inputs/prepare/",
    upload: "/api/inputs/upload/",
    uploadProgress: "/api/inputs/upload-progress/",
    tableData: "/api/inputs/bq-table-data/",
    downloadHistorical: "/api/inputs/download-historical/",
    variants: "/api/inputs/variants/",
    variantTags: "/api/inputs/variants/tags/",
    ingestionColumns: "/api/inputs/ingestion-columns/",
    cleanup: "/api/inputs/cleanup/",
    modelDimensions: "/api/inputs/model-dimensions/",

    // Setup Keys
    setupKeys: "/TBC/",
  },

  // Setup
  setup: {
    setupkeyMappings: "/api/setup/setupkey-mappings/",
  },

  // // Setup NÃO USADO
  // setup: {
  //   keys: "/api/setup/config/",
  // },

  // Executive
  executive: {
    // Company
    financialPerformance: "/api/executive/company-card1/",
    investmentManagement: "/api/executive/company-card2/",
    // Channels
    channelTransparency: "/api/executive/channels-card1/",
    chainMonitoring: "/api/executive/channels-card2/",
    // Market
    competitionPositioning: "/api/executive/market-card1/",
    volumeMarketShare: "/api/executive/market-card2/",
  },

  // Programs
  programs: {
    list: "/api/programs/",
    create: "/api/programs/create/",
    detail: "/api/programs/", // + {program_id}/
    update: "/api/programs/", // + {program_id}/update/
    delete: "/api/programs/", // + {program_id}/delete/
    addScenario: "/api/programs/", // + {program_id}/scenarios/
    updateScenario: "/api/programs/", // + {program_id}/scenarios/{ps_id}/
    removeScenario: "/api/programs/", // + {program_id}/scenarios/{ps_id}/remove/
    availableScenarios: "/api/programs/", // + {program_id}/available-scenarios/
  },

  // Cockpit
  cockpit: {
    start: "/api/cockpit/start-calculations/",
    maskConfig: "/api/cockpit/mask-config/",
    variants: "/api/cockpit/variants/",
    schemaInputs: "/api/cockpit/schema-inputs/",
    scenariosData: "/api/cockpit/scenarios-data/",
    outputTable: "/api/cockpit/output-table/",
    scenarioDetails: "/api/cockpit/scenario-details/",
    updateScenario: "/api/cockpit/update-scenario/",
    deleteScenario: "/api/cockpit/delete-scenario/",
    mapData: "/api/cockpit/map-data/",
    filterOptions: "/api/cockpit/filter-options/",
    pnlFilterOptions: "/api/cockpit/pnl-filter-options/",
    filteredMapData: "/api/cockpit/filtered-map-data/",
    filteredOutputTable: "/api/cockpit/filtered-output-table/",
    PnlData: "/api/cockpit/pnl-data/",
    mergeAnalysis: "/api/cockpit/merge-analysis/",
    comparisons: "/api/cockpit/comparisons/",
    comparisonCreate: "/api/cockpit/comparisons/create/",
    comparisonUpdate: "/api/cockpit/comparisons/update/",
    comparisonDelete: "/api/cockpit/comparisons/delete/",
    comparisonData: "/api/cockpit/comparisons/data/",
    comparisonFilterOptions: "/api/cockpit/comparisons/filter-options/",
    comparisonMetadata: "/api/cockpit/comparisons/metadata/",
    priceRouteDimensions: "/api/cockpit/priceroute-dimensions/",
    topClients: "/api/cockpit/top-clients/",
    downloadProgress: "/api/cockpit/download-progress/",
    chainVisualization: "/api/cockpit/chain-visualization/",
    pnlDownload: "/api/cockpit/pnl-download/",
    modelsPremises: "/api/cockpit/models-premises/",
    downloadMissingValues: "/api/cockpit/download-missing-values/",
    priceRouteData: "/api/cockpit/priceroute-data/",
    priceRouteDownload: "/api/cockpit/priceroute-download/",
    priceRouteFilterOptions: "/api/cockpit/priceroute-filter-options/",
    // Folder management
    folders: "/api/cockpit/folders/",
    foldersCreate: "/api/cockpit/folders/create/",
    // Scenario archive
    scenariosArchive: "/api/cockpit/scenarios/archive/",
  },
};

export default apiRoutes;
